import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { NhanSuService } from '../services/nhan-su.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  homeUrl: string;
  loginForm: FormGroup;
  constructor(private router: Router, private messageService: MessageService, private nhanVienService: NhanSuService) {
    this.homeUrl = '/home';
    this.loginForm = new FormGroup({
      username: new FormControl('', [Validators.required, Validators.minLength(4)]),
      password: new FormControl('', [Validators.required, Validators.minLength(1)])
    });
  }

  ngOnInit(): void {

  }

  Login() {
    if (this.loginForm.valid) {
      let username: any = this.loginForm.controls.username.value;
      let password = this.loginForm.controls.password.value;
      let loginData = new FormData();
      loginData.append('username', username);
      loginData.append('password', password);
      this.nhanVienService.checkUser(loginData).subscribe(
        (resp: any) => {
          if (resp != undefined && resp != null) {
            if (resp.flag === 1) {
              localStorage.setItem('hovaten', resp.hoVaTen);
              localStorage.setItem('quyen', resp.quyen);
              localStorage.setItem('iduser', resp.iduser);
              localStorage.setItem('isLoginedIn', 'true');
              this.messageService.add({ severity: 'success', summary: 'Thông báo', detail: 'Đăng nhập thành công!' });
              this.router.navigate([this.homeUrl]);
              
            }
          }
        },
        (error: any) => {
          localStorage.setItem('isLoginedIn', 'false');
          this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Thông tin đăng nhập không chính xác!' });
        }
      );

      // console.log(username);
      // if (username == "admin" && password == "admin") {
      //   localStorage.setItem('isLoginedIn', 'true');
      //   this.router.navigate([this.homeUrl]);
      // }
      // else {
      //   localStorage.setItem('isLoginedIn', 'false');
        
      // }
    }
  }
}
